import { Link } from "react-router-dom";
import { SENFULLY_APP_URL } from "../appConfig";
import { Icon } from "./Icon";
import "./styles/CtaBand.css";

export function CtaBand() {
  return (
    <section className="cta-band container" aria-labelledby="cta-title">
      <div className="cta-band__surface">
        <h2 id="cta-title">Ready to bring everyone together?</h2>
        <p>Request access in under a minute. Already have an account? Log in and carry on where you left off.</p>
        <div className="cta-band__actions">
          <Link to="/get-senfully" className="btn btn--light btn--lg">
            Get SENfully
            <Icon name="arrow-right" size={18} />
          </Link>
          <a href={SENFULLY_APP_URL} className="btn btn--outline-light btn--lg">Log in</a>
        </div>
      </div>
    </section>
  );
}
